import React from "react";
import { HeroSection } from "../components/index";
export default function Home() {
  return (
    <div className="w-screen h-auto bg-black">
      <HeroSection />
    </div>
  );
}
